import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { formatApiErrorDetail } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VerifyEmailBanner = ({ email }) => {
  const [sending, setSending] = useState(false);
  const resend = async () => {
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/auth/resend-verification`);
      toast.success(data.status === "sent" ? "Sent. Check your inbox (and spam)." : "Already confirmed.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSending(false);
    }
  };
  return (
    <div data-testid="verify-email-banner" className="mb-6 border border-[#F59E0B]/40 bg-[#F59E0B]/5 px-5 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="flex items-start gap-3">
        <MailCheck size={18} className="text-[#B45309] mt-0.5 shrink-0" />
        <div>
          <p className="text-[#1C1917] text-base">Confirm your email — we sent a link to <span className="text-[#B45309]">{email}</span>.</p>
          <p className="text-[#78716C] text-sm">This links any purchase you made before signing up.</p>
        </div>
      </div>
      <button onClick={resend} disabled={sending} data-testid="verify-resend-btn" className="btn-outline text-xs w-fit shrink-0 disabled:opacity-50">
        {sending ? "Sending…" : "Resend the email"}
      </button>
    </div>
  );
};
